import * as React from "react";
import createSvgIcon from "./utils/create_svg_icon";

export default createSvgIcon(
  <path d="M 5 13.710938 L 0.148438 8.851562 L 0.851562 8.148438 L 5 12.289062 L 15.148438 2.148438 L 15.851562 2.851562 Z M 5 13.710938 " />,
  "Accept",
);
